import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { captureImageException } from 'Utilities/captureException/captureImageException';
import { formatImageURLWithMeta } from 'Utilities/formatters';
import { applyCypressData } from 'Utilities/helpers';
import proPropTypes from 'Utilities/proPropTypes';

import styles from './LazyLoadImage.module.scss';

const BaseImage = (
	{ className, img, isSecondaryBackground, loaded }, // eslint-disable-line react/prop-types
) => (
	<div className={cx(styles.imagesBox, { [styles.imageLoaded]: loaded }, className)} data-loaded={loaded}>
		<div data-placeholder className={cx(styles.imagePlaceholder, { [styles.greyBackground]: isSecondaryBackground })} />
		{img}
	</div>
);

const LazyLoadImage = ({
	alt = '',
	classNames = {},
	cypressId,
	height = 252,
	isSecondaryBackground = false,
	photo = {},
	rootComponent,
	width = 336,
}) => {
	const $img = useRef();
	const [loaded, setLoaded] = useState(false);

	const onLoad = () => setLoaded(true);

	const onError = (event) => {
		captureImageException({
			event,
			imageComponent: 'LazyLoadImage',
			rootComponent,
		});
	};

	useEffect(() => {
		if ($img.current?.complete) {
			onLoad();
		}
	}, []);

	return (
		<BaseImage
			className={classNames?.container}
			img={
				photo.url && (
					<img
						ref={$img}
						alt={alt}
						className={classNames?.image}
						height={height}
						loading="lazy"
						onError={onError}
						onLoad={onLoad}
						src={formatImageURLWithMeta(photo, {
							bg: '1D1D1B',
							fit: 'fill',
							h: height,
							w: width,
						})}
						width={width}
						{...applyCypressData(cypressId)}
					/>
				)
			}
			isSecondaryBackground={isSecondaryBackground}
			loaded={loaded}
		/>
	);
};

LazyLoadImage.propTypes = {
	alt: PropTypes.string,
	classNames: PropTypes.shape({
		container: proPropTypes.className,
		image: proPropTypes.className,
	}),
	cypressId: PropTypes.string,
	height: proPropTypes.stringOrNumber,
	isSecondaryBackground: PropTypes.bool,
	photo: proPropTypes.leadPhoto,
	rootComponent: PropTypes.string,
	width: proPropTypes.stringOrNumber,
};

export default LazyLoadImage;
